import { Flex, Text } from "@chakra-ui/react";
import { Content } from "./Content";
import { Layout } from "./layout";

export function NotAllowed() {

  return (
    <Layout>
      <Content sx={{ minHeight: 'calc(100dvh - 66px)' }}>
        <Flex flex="1" alignItems="center" justifyContent="center">
          <Text fontSize="20px" fontWeight="600">Not allowed</Text>
        </Flex>
      </Content>
    </Layout>
  )
}